import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable";
import { db, balaCollection, userDataCollection } from "@/firebase";
import { breaking } from "vuetify/src/util/console";
import { Module } from "@/store/enums.ts";

@Component
export default class WritingTask2Planning extends Vue {
  @Prop({ default: false }) dialogMode!: boolean;
  @Prop({ default: false }) closeDialog!: { open: boolean };

  dialog = false;
  valid = true;
  planning = ["- reason 1...\n-\n-\n-\n-", "- idea 1...\n-\n-\n-\n-"];

  private _questions: any;

  constructor() {
    super();
    this._questions = this.$store.getters.balaWPlanning.writingTask2;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balaWPlanning.writingTask2;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item: any) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return this.$store.getters.balaSections[8].sectionProgress.Planning == 100;
  }

  submit() {
    if (this.$store.getters.balaSections[8].sectionProgress.Planning != 100) {
      var thisUser = this.$store.getters.user;
      var uid = thisUser.data.uid;

      let timepoint = this.$store.getters.balaTimepointStr;
      let data = this.getData();

      // Store question answers
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("writingTask2")
        .set(
          {
            PlanningAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.writingTask2.planning": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {});

      // Update progress in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Writing Task 2",
        subsection: "Planning"
      });
    }
    this.$router.push({ name: "balaWT2Response" });
  }

  private dataLoaded() {
    return this.$store.getters.balaWPlanning.writingTask2Loaded;
  }

  render(h: CreateElement) {
    return (
      this.dataLoaded() && (
        <Card title="Planning" mod={Module.BALA}>
          <div slot="mainContent">
            <v-toolbar flat>
              You have just watched a video about global warming. Let’s plan
              your writing using the box below.
            </v-toolbar>

            <v-simple-table fixed-header height="200px">
              <thead>
                <tr>
                  <th class="text-left">{this._questions[0].question}</th>
                  <th class="text-left">{this._questions[1].question}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <v-textarea
                      v-model={this._questions[0].answer}
                      disabled={this.dialogMode || this.isComplete()}
                      counter
                      // rules={[
                      //   (v: any) =>
                      //     (v.length > 0 && v.length < 300) || "Max 300 characters"
                      // ]}
                      placeholder="Start writing here..."
                    ></v-textarea>
                  </td>
                  <td>
                    <v-textarea
                      v-model={this._questions[1].answer}
                      disabled={this.dialogMode || this.isComplete()}
                      counter
                      // rules={[
                      //   (v: any) =>
                      //     (v.length > 0 && v.length < 300) || "Max 300 characters"
                      // ]}
                      placeholder="Start writing here..."
                    ></v-textarea>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
          <div slot="actions">
            <v-spacer></v-spacer>
            {!this.dialogMode ? (
              <v-btn
                disabled={!this.valid}
                color="secondary"
                onClick={this.submit}
              >
                Next
              </v-btn>
            ) : (
              <v-btn
                color="secondary"
                onClick={() => {
                  this.closeDialog.open = false;
                }}
              >
                Close
              </v-btn>
            )}
          </div>
          <div slot="progressBar">
            <v-spacer></v-spacer>
            <v-progress-linear
              value={0}
              height="4"
              opacity="0.3"
              striped={true}
            ></v-progress-linear>
          </div>
        </Card>
      )
    );
  }
}

const component = WritingTask2Planning;
